import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_LMS_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserData, getUserId } from "../../Base/helper/baseFunctions";


export const GetLeaveTypesHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/ancillary/lms/getLeaveTypes`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: params?.domain_name || data.domain,
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}


export const AddLeaveTypesHelper = async (params) => {
    var data = getUserData();
    toast.info("Saving...")
    return await axiosInstance(`/ancillary/lms/addLeaveType`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_emp_id: data?.employee_id,
            name: params?.name,
            code: params?.code,
            actual_days: params?.leave_type === "variable" ? null : params?.actual_days,
            req_second_approval: params?.req_second_approval || false,
            colour_code: params?.colour_code,
            cfwd_leave: params?.cfwd_leave || false,
            noof_cfwd_days: params?.noof_cfwd_days || 0,
            gender: params?.gender?.name || "",
            gender_based: params?.gender_based,
            is_unlimited: params?.is_unlimited || false,
            leave_type: params?.leave_type,
            yearly_credit: params?.leave_type === "flat" ? params?.actual_days : params?.credit_type === "yearly_accrual" ? params?.yearly_credit : null,
            monthly_credit: params?.credit_type === "monthly_accrual" ? params?.monthly_credit : null,
            credit_type: params?.leave_type === "flat" ? "yearly_accrual" : params?.credit_type || "",
            credit_time: params?.credit_time || "",
            is_attendance_considered: params?.is_attendance_considered || false,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Leave Type Added Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateLeaveTypesHelper = async (params) => {
    var data = getUserData();
    toast.info("Saving...")
    return await axiosInstance(`/ancillary/lms/updateLeaveType`, {
        method: "PUT",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_emp_id: data?.employee_id,
            leavetype_id: params?.leavetype_id,
            name: params?.name,
            code: params?.code,
            actual_days: params?.leave_type === "variable" ? null : params?.actual_days,
            req_second_approval: params?.req_second_approval || false,
            colour_code: params?.colour_code,
            cfwd_leave: params?.cfwd_leave || false,
            noof_cfwd_days: params?.noof_cfwd_days || 0,
            gender: params?.gender?.name || "",
            gender_based: params?.gender_based,
            is_unlimited: params?.is_unlimited || false,
            leave_type: params?.leave_type,
            yearly_credit: params?.leave_type === "flat" ? params?.actual_days : params?.credit_type === "yearly_accrual" ? params?.yearly_credit : null,
            monthly_credit: params?.credit_type === "monthly_accrual" ? params?.monthly_credit : null,
            credit_type: params?.leave_type === "flat" ? "yearly_accrual" : params?.credit_type || "",
            credit_time: params?.credit_time || "",
            is_attendance_considered: params?.is_attendance_considered || false,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Leave Type Updated Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const DeleteLeaveTypesHelper = async (params) => {
    var data = getUserData();
    toast.info("Deleting...")
    return await axiosInstance(`/ancillary/lms/deleteLeaveType`, {
        method: "DELETE",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            leavetype_id: params?.leavetype_id,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Leave Type Deleted Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetLeaveCreditConfigHelper = async () => {
    return await axiosInstance(`/ancillary/lms/getLeaveCreditConfig`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateLeaveCreditConfigHelper = async (params) => {
    toast.info("Saving...")
    return await axiosInstance(`/ancillary/lms/updateLeaveCreditConfig`, {
        method: "PUT",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            leave_credit_configuration_pk: params?.leave_credit_configuration_pk,
            leavetype_fk: params?.leavetype_id?.leavetype_id,
            user_id: getUserId(),
            credit_type: params?.credit_type,
            credit_time: params?.credit_time,
            yearlycredit: params?.credit_type === "yearly_accrual" ? params?.yearlycredit : "0",
            monthlycredit: params?.credit_type === "monthly_accrual" ? params?.monthlycredit : "0",
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Leave credit configured  successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetLeaveAccrualTypeHelper = async () => {
    return await axiosInstance(`/ancillary/lms/getLeaveAccrualType`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain()
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateLeaveAccrualTypeHelper = async (params) => {
    var data = getUserData();
    toast.info("Saving...")
    return await axiosInstance(`/ancillary/lms/updateLeaveAccrualType`, {
        method: "PUT",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            user_emp_id: data?.employee_id,
            year_type: params?.year_type,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Leave Year Type Updated Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
